<!-- TEMPLATE UTILIZADA EN LA HOME, EN LA FRANJA VERDE DE SELECCIÓN DE ACTIVIDAD-->
<template lang="html">

    <section class="banner-calendario column-center">

        <h1 v-html="$t('Titulo buscador home')"></h1>

        <p v-html="$t('Cuerpo buscador home')"></p>

        <div class="selector" id="selector_home2">
            <label for="actividadescalendario" style="display: none;">Actividades</label>
            <select v-model="data.categorie" :open-date="data.date_start" v-validate="'required'" aria-label="actividadescalendario">
            <!-- Comprobamos si hay categorías y mostramos el mensaje correspondiente -->
            <option value="">
                {{ categorias.filter(c => c.visible == 1).length > 0 ? 'Seleccione un programa de actividades' : 'No hay actividades programadas actualmente' }}
            </option>
            <option :value="option.slug" v-if="option.visible == 1 && !option.mother_id" v-for="(option,key) in categorias">
                    {{option.name}}
            </option>
            </select>
            <select v-model="data.subcategorie" v-if="childs && childs.length != 0" aria-label="Subcategoria">
                <option value="">Subcategoría</option>
                <option :value="option.slug" v-if="option.visible == 1" v-for="(option,key) in childs">{{option.name}}
                </option>
            </select>
            <button class="btn green" @click="toRequest">Buscar</button>
        </div>

    </section>

</template>

<script lang="js">

    import Datepicker from 'vuejs-datepicker';

    import { en, es } from 'vuejs-datepicker/dist/locale'

    import { mapActions, mapGetters } from 'vuex';

    import router from '@/router';

    import moment from 'moment';

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';

    Vue.use(VeeValidate);

    export default {
        name: 'banner-calendario',
        data() {
            return {
                en: en,
                es: es,
                clicked : false,
                data: {
                    date_start: '',
                    date_end: '',
                    categorie: '',
                    subcategorie: ''
                },
                disabledDates: {
                    to: new Date(moment().add(1, 'days')),
                    from: new Date(2023, 0, 1)
                }
            }
        },
        computed: {
            ...mapGetters({
                categorias: 'getCategorias'
            }),
            childs() {

                let childs;

                if (this.categorias && this.categorias.length != 0) {
                    if (this.categorias.filter(c => c.slug == this.data.categorie).length != 0) {
                        childs = this.categorias.filter(c => c.slug == this.data.categorie)[0].childs;
                    }
                }

                return childs;

            }
        },
        methods: {
            ...mapActions(['requestActividadesBydate']),
            toRequest() {

                this.clicked = true;
                this.$validator.validateAll().then(canSend => {
                    if (canSend) {




                        let inicio;
                        let fin;
                        let selected;

                        if (this.data.date_start) {
                            inicio = new Date(this.data.date_start).toISOString().substring(0, 10);
                        }

                        if (this.data.date_end) {
                            fin = new Date(this.data.date_end).toISOString().substring(0, 10);
                        }


                        router.push({
                            name: 'categoria',
                            params: {
                                id: (this.data.subcategorie) ? this.data.subcategorie : this.data.categorie
                            },
                            query: {
                                date_start: inicio,
                                date_end: fin
                            }
                        })

                    }
                });

            },

        },
        components: {
            Datepicker
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/banner-buscador-calendario.vue